module.exports = __webpack_public_path__ + "static/media/banner.99f3b73b.jpg";